'use strict';
import util from '../util';
import header from '../header';
import currentLayout from '../detect-layout';
import analytics from '../analytics';
import search from "../pages/search";
import crossSellTabs from "../pages/cross_sell_tabs";
import { isEmpty } from 'lodash-es';
var currentQuery = null,
	lastQuery = null,
	runningQuery = null,
	listTotal = -1,
	listCurrent = -1,
	delay = 30,
	searchSuggestioncallTimeout = null,
	$popularResultsContainer = $('.popular-search-overlay');

function updateSlickStyle() {
	crossSellTabs.init();
	const windowWidth = $(window).width();
    const $productSuggestionList = $('.product-suggestion-list');
    const $einsteinRecommender = $('.product-suggestion-list.einstein-recommender');
	
    function initializeSlick() {
        $einsteinRecommender.not('.slick-initialized').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
            prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>',
        });
    }

    function destroySlick() {
        if ($einsteinRecommender.hasClass('slick-initialized')) {
            $einsteinRecommender.slick('unslick');
        }
    }

    if (windowWidth < 769) {
        $productSuggestionList.css('width', windowWidth);
        destroySlick();
    } else if (windowWidth >= 1150) {
        $productSuggestionList.removeAttr("style");
        const pairsElemts = $('.product-tile-wrapper + .gtm-search-tile');
        pairsElemts.each(function () {
            $(this).prev('.product-tile-wrapper').addBack().wrapAll('<div class="wrapper"></div>');
        });
        setTimeout(() => {
            if ($productSuggestionList.find('.product-tile-outer').length > 2 && $productSuggestionList.hasClass('einstein-recommender')) {
                initializeSlick();
            }
        }, 300);
        $(document).on('click', '.slick-next, .slick-prev', function (e) {
            e.preventDefault();
        });
    } else {
        $productSuggestionList.removeAttr("style");
        destroySlick();
    }
}

/**
 * recent searches remove
 */
function removeRecentSearches() {
	// Cache jQuery selectors
	const $recentSearchCont = $('.recent-search-cont');
	const $cancelResult = $('.search-redesign-container .recent-search-wrapper .cancel-result');

	// remove recent search keyword
	$cancelResult.on('click', function (e) {
		const removeTextSel = $(this).closest('li.item').attr('data-category');
		$(this).closest('li.item').remove();
		let recentText = util.getCookieValue('recentSearchSuggest');
		recentText = recentText ? decodeURIComponent(recentText) : '';
		recentText = recentText.replace(/^["'](.+(?=["']$))["']$/, '$1'); // remove explicitly added strings
	
		let recentTextArray = recentText ? recentText.split(',') : [];
		const index = recentTextArray.indexOf(removeTextSel);
		if (index > -1) {
			recentTextArray.splice(index, 1);
		}
	
		const resultSet = recentTextArray.filter((el) => el != null);
		if (resultSet.length > 1) {
			$recentSearchCont.find(".popular-search-title").text(Resources.RECENTSEARCHES);
		} else {
			$recentSearchCont.find(".popular-search-title").text(Resources.RECENTSEARCH);
		}
		if (isEmpty(resultSet)) {
			util.setCookie('recentSearchSuggest', '');
			$recentSearchCont.addClass("hidden");
		} else {
			let cookiesExp = SitePreferences.RECENT_SEARCH_COOKIES_EXP; // in secs
			cookiesExp = Math.floor(cookiesExp / 60); // in minutes
			util.setCookie('recentSearchSuggest', encodeURIComponent(resultSet.join(',')), cookiesExp);
			$recentSearchCont.removeClass('hidden');
		}
	});
}

function closeSearchOverlay() {
    const $html = $('html');
    const $body = $('body');
    const $searchSuggestions = $('#search-suggestions');
    $html.removeClass('sticky-header-search modal-open');
    if ($(window).width() > 991) {
        $('.search-btn-close').hide();
        $(".search-redesign-container").removeAttr('style');
        setTimeout(() => {
            $body.removeClass('suggestions-wrapper_active');
			$(".search-title").focus().val("");
        }, 500);
    } else {
		setTimeout(() => {
            $body.removeClass('suggestions-wrapper_active');
			if($('.nav-redesign').length) {
				$('.page-layout').find('.container.inner-top-container').css('margin-top', '0');
			}
        }, 500);
    }
    $searchSuggestions.removeClass('query-search, popular-search');
}

var searchsuggest = {
	/**
	 * @function
	 * @description Configures parameters and required object instances
	 */
	init: function (container, defaultValue) {
		const searchContainer = $(container);
		const searchForm = searchContainer.find('form[name="simpleSearch"]');
		const searchField = searchForm.find('input[name="q"]');
		const submitButton = searchForm.find('button[type="submit"]');
		const cancelButton = searchForm.find('button[type="reset"]');
		const closeButton = $('.header-search-wrapper').find('.close-wrapper');
		// disable browser auto complete
		$('#suggestions-redesign-enabled').length > 0 && $('html').addClass('suggestions-enabled');
		searchField.attr('autocomplete', 'off');
		$(closeButton).hide();

		// Search overlay show/hide
		$('.header-search .icon-close, .suggestions-overlay').on('click keydown', function (e) {
			if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
				return;
			}

			if (e.type === 'keydown') {
				e.preventDefault(); // prevent scroll on Space
			}
			e.preventDefault();
			$(".search-redesign-container").removeClass('active');
			$($popularResultsContainer).html('');
			closeSearchOverlay();
			cancelButton.trigger('click');
			$('.new-ico.ico-search').show();
		}.bind(this));
		
		$(document).find('.hidden-button-search-focus').on('click', function() {
			$('.search-text.hint-text').focus();
		});

		$('.js-search-link').on('click keydown', function (e) {
			if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
				return;
			}

			if (e.type === 'keydown') {
				e.preventDefault(); // prevent scroll on Space
			}
			e.preventDefault();
			$('.close-wrapper.mobile-nav-close').trigger('click');
			if (!$('.home-page').length) {
				$('html').toggleClass('sticky-header-search');
			}
			this.showSearch();
			runningQuery = null;
			currentQuery = null;
			this.popularSearch(runningQuery);
			$('#search-suggestions').removeClass('query-search').addClass('popular-search');
			if (searchField.val() === defaultValue) {
				searchField.val('');
			}
			setTimeout(() => {
				if ($('body').hasClass('suggestions-wrapper_active')) {
					analytics.searchOverlayShow();
				}
				$('.hidden-button-search-focus').trigger('click');
			}, 0);
			return false;
		}.bind(this));

		$('.search-btn').on('click', function (e) {
			e.preventDefault();
			closeSearchOverlay();
			$('.new-ico.ico-search').show();
		}.bind(this));

		// cancel button hide
		cancelButton.on('click', function (e) {
			e.stopPropagation();
			$('.home-page form[name="simpleSearch"] input[name="q"]').blur();
			lastQuery = null;
			runningQuery = null;
			currentQuery = null;
			cancelButton.hide();
			submitButton.prop('disabled', true);
			$(searchField).removeClass('active-style');
			runningQuery = null;
			currentQuery = null;
			this.popularSearch(runningQuery);
			$('#search-suggestions').removeClass('query-search').addClass('popular-search');
		}.bind(this));

		// on blur listener
		searchField.on('blur', function (e) {
			this.checkInput(e, searchField, submitButton, defaultValue);
			$('#q-hint').val('');
		}.bind(this));

		searchField.on('input', function () {
			$(searchField).addClass('active-style');
			setTimeout(() => {
				$(searchField).trigger('focus');
				$(searchField).trigger('click');
			}, 500);
			if ($(this).val() != $('#q-hint').val()) {
				$('#q-hint').val('');
			}
		});
		// on key up listener
		searchField.off().on('keyup', function (e) {
			// get display cancel button on type
			if (searchField.val().trim().length > 0) {
				cancelButton.show();
			} else {
				// Hide hint text.
				$('#q-hint').val('');
				cancelButton.hide();
				$('#search-suggestions').removeClass('query-search').addClass('popular-search');
			}

			// get keyCode (window.event is for IE)
			var keyCode = e.keyCode || window.event.keyCode;

			// check for an ENTER or ESC
			if (keyCode === 13 || keyCode === 27) {
				this.checkInput(e, searchField, submitButton, defaultValue);
				$('#q-hint').val('');
				return;
			}

			currentQuery = searchField.val().trim();
			clearTimeout(searchSuggestioncallTimeout);

			// no query currently running, init an update
			searchSuggestioncallTimeout = setTimeout(function () {
				if (currentQuery.length > 2 && lastQuery != currentQuery) {
					lastQuery = currentQuery;
					runningQuery = currentQuery;
					this.popularSearch(searchField.val().trim());
				} else if (currentQuery.length == 0) {
					lastQuery = null;
					this.popularSearch(null);
				}

			}.bind(this), 700);
		}.bind(this));

		submitButton.on('click', function (e) {
			e.preventDefault();
			searchForm.find('input[name="q"]').val(searchField.val().trim());
			this.checkInput(e, searchField, submitButton, defaultValue);
			searchForm.submit();
		}.bind(this));

		window.addEventListener('resize', util.debounce(() => {
			updateSlickStyle();
			checkToInitSlickSlider();
			searchOverlayMobileSlider();
		  }, 200));
	},
	checkInput: function (e, searchField, submitButton, defaultValue) {
		if (searchField.val().trim().toLowerCase() == defaultValue.toLowerCase()) {
			e.stopImmediatePropagation();
			searchField.val(defaultValue);
			return false;
		}
	},

	showSearch: function () {
		
		updateSuggestionsContainerHeight();
		$('body').addClass('suggestions-wrapper_active');
		$('html').addClass('modal-open');
		$('.new-ico.ico-search').hide();
		$(window).width() > 991 && $('.search-btn-close').show();
		setTimeout(() => {
			const $searchTextValue = $(".search-title").val();
			$('.search-redesign-container').addClass('active');
			if($('.popular-suggestion-container').length <=0) {
				$('.ajax-loader.searchoverlay-loader').show();
			}
			$(".search-text.entered-text").val($searchTextValue);
			
		}, 100);
		$('.hidden-button-search-focus').trigger('click');
	},
	/**
	 * @function
	 * @description: execute server call for popular search
	 */
    popularSearch: function (query) {
        var popularSearchUrl = util.appendParamsToUrl(Urls.getPopularSearchSuggest, { 'q': query, 'format': 'ajax' });
		const $loader = $('.ajax-loader.searchoverlay-loader');
		if($('.nav-redesign').length && $(window).width() < 991) {
			$('.page-layout').find('.container.inner-top-container').css('margin-top', '-35px');
			if($('.suggestions-enabled').hasClass('modal-open')) {
				$('.search-btn-close.icon-close').show();
			}
		}
		
        function handlePopularSearchResponse(data) {
            $popularResultsContainer.html(data);
            $('.search-redesign-container .entered-text').trigger("focus");
			updateSlickStyle();
			checkToInitSlickSlider();
			searchOverlayMobileSlider();
			
            const $searchContainer = $('.search-redesign-container');
            const $productTileOuter = $('.suggestions-wrapper_active .product-tile-outer');
            const $productSuggestionWrapper = $('.product-suggestion-wrapper');
            const $productSuggestionList = $('.product-suggestion-list');
			const $suggestionsContainer = $('.suggestions-wrapper_redesign .suggestions-container');
			const $noSearchResult = $('.no-search-result');
			const $searchResultsAppeared = $('.search-results-appeared');

            $productTileOuter.find('.product-tile .product-name').css('-webkit-box-orient', 'vertical');
            if ($productSuggestionWrapper.find('.product-tile-outer').length > 4 && !$productSuggestionList.hasClass('einstein-recommender')) {
                $productSuggestionWrapper.addClass('autoHeight');
                $searchContainer.addClass('autoHeight');
            }
            $('.product-no-result').length > 0 && $productSuggestionWrapper.addClass('autoHeight');
            $noSearchResult.length > 0 ? $suggestionsContainer.addClass('no-result') : $suggestionsContainer.removeClass('no-result');
            $(window).width() > 991 && $searchResultsAppeared.length > 0 ? $searchContainer.css('height', $(window).innerHeight() - 60 + 'px') : $searchContainer.removeAttr('style');

			const setSearchContainerHeight = util.debounce(() => { //  improve the performance, maintainability, and security of your code.
                if ($(window).width() > 991 && $noSearchResult.length > 0) {
                    $searchContainer.css('height', '800px');
                } else {
                    !$searchResultsAppeared.length > 0 && $searchContainer.removeAttr('style');
                }
            }, 200);

            setSearchContainerHeight();

            // analytics datalayer for Search Overlay
            setTimeout(() => {
                const $body = $('body');
                const $searchContainer = $(".search-redesign-container");

                $body.hasClass('suggestions-wrapper_active') && analytics.searchEinstienProductList();

				$(".search-redesign-container .product-tile-outer .product-tile").on('click', function (e) {
					analytics.searchProductTile($(this));
				});

                $(".search-redesign-container .popular-search-list a, .search-redesign-container .category-wrapper a, .search-redesign-container .suggestion-wrapper a, .search-redesign-container .suggestion-header .link").on('click', function (e) {
					analytics.searchCategoryLink($(this));
				});

                removeRecentSearches();
            }, 0);
			// load first tab content
			$(".suggestion-header .top-tabs-wrapper .tab:first-child button.cs-tab").trigger("click");
        }

        $.get(popularSearchUrl, handlePopularSearchResponse)
            .done(function () {
                $loader.hide();
            })
            .fail(function () {
                // Hide the loader even if the request fails
                $loader.hide();
                // Handle the error
            }).always(function () {
                $loader.hide();
            })
    }
};

const updateSuggestionsContainerHeight = util.debounce(() => { //  improve the performance, maintainability, and security of your code.
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const suggestionsContainer = document.querySelector('.suggestions-container');
    if (suggestionsContainer) {
        const availableHeight = Math.max(0, window.innerHeight - 130); // Ensure non-negative value
        if (isMobile) {
            window.requestAnimationFrame(() => { // Utilize window.requestAnimationFrame to ensure smoother updates during animations or frequent changes.
                suggestionsContainer.style.maxHeight = availableHeight + 'px';
            });
        } else {
			// remove style for desktop
			suggestionsContainer.removeAttribute('style');
		}
    }
}, 200);

window.addEventListener('resize', updateSuggestionsContainerHeight);

// search overlay Mobile carousel initialization 
function searchOverlayMobileSlider() {
    const searchOverlaySelector = $('.popular-suggestion-wrapper .product-suggestion-list');
    searchOverlaySelector.each(function (index, ele) {
        if ($('.product-suggestion-wrapper.einstein-recommender-wrapper').length && $(window).width() < 991) {
            OverlayScrollbars($(ele), {});
        } else {
            OverlayScrollbars($(ele), {}).destroy(); // Disable for desktop screen
        }
    });
}

function checkToInitSlickSlider() {
    let isDesktop = window.matchMedia("(min-width: 1025px)").matches;
    let suggestionWrapperLength = $('.product-suggestion-wrapper.einstein-recommender-wrapper');
	if(isDesktop && suggestionWrapperLength.length > 0 && !window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
		search.initPLPSlider();
	}
	if(suggestionWrapperLength.length <= 0) {
		if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
			search.initPLPSlider();
		}
	}
}

export default searchsuggest;